import styled from "styled-components";

import { SCENSUM_WEBSITE_HEADER_HEIGHT } from "../../constants/constants";

// Limts the width of the breadcrums list
export const _WidthContainer = styled.div`
  flex-direction: row;
  display: flex;
  flex-grow: 1;
  flex-basis: 0;
  justify-content: space-between;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;

  @media (min-width: 768px) {
    padding: 10px;
  }
`;

export const _ListContainer = styled.div`
  position: fixed;
  top: ${SCENSUM_WEBSITE_HEADER_HEIGHT};
  width: 100%;
  z-index: calc(99 + 1);
  background: ${({ theme }) => theme.progressBar};

  @media (min-width: 768px) {
    position: initial;
  }
`;
